<template>
  <div class="body" :class="bodyVariable">
    <div v-if="!iframe" class="row flex items-center">
      <div class="col-8"></div>
      <div class="col-4 flex">
        <a :href="linkFB" target="_blank" :class="'text-btn-'+mainClass">
            <svg style="width: 34px; height: 34px; margin-right: 7px;" id="Capa_1" data-name="Capa 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52.2 52.2">
              <g id="Capa_1-2" data-name="Capa 1">
                <path fill="currentColor" d="M26.1,0C11.69,0,0,11.69,0,26.1s11.69,26.1,26.1,26.1,26.1-11.69,26.1-26.1S40.52,0,26.1,0ZM36.37,13.18h-3.06c-3.01,0-3.95,1.87-3.95,3.79v4.55h6.72l-1.07,7.01h-5.65v16.94h-7.58v-16.94h-6.16v-7.01h6.16v-5.34c0-6.08,3.62-9.43,9.16-9.43,2.65,0,5.43.47,5.43.47v5.97Z"/>
              </g>
            </svg>
        </a>
        <a :href="linkIN" target="_blank" :class="'text-btn-'+mainClass">
            <svg style="width: 34px; height: 34px; margin-right: 7px;" id="Capa_2" data-name="Capa 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52.2 52.2">
              <g id="Capa_2-2" data-name="Capa 1">
                <path fill="currentColor" d="M26.1,0C11.69,0,0,11.69,0,26.1s11.69,26.1,26.1,26.1,26.1-11.69,26.1-26.1S40.52,0,26.1,0ZM41.92,32.42c0,5.24-4.26,9.5-9.5,9.5h-12.63c-5.24,0-9.5-4.26-9.5-9.5v-12.63c0-5.24,4.26-9.5,9.5-9.5h12.63c5.24,0,9.5,4.26,9.5,9.5v12.63ZM31.22,26.1c0,2.75-2.24,4.99-4.99,4.99s-4.99-2.24-4.99-4.99,2.24-4.99,4.99-4.99,4.99,2.24,4.99,4.99ZM32.42,13.26h-12.63c-3.6,0-6.53,2.93-6.53,6.53v12.63c0,3.6,2.93,6.53,6.53,6.53h12.63c3.6,0,6.53-2.93,6.53-6.53v-12.63c0-3.6-2.93-6.53-6.53-6.53ZM26.23,33.89c-4.3,0-7.79-3.5-7.79-7.79s3.5-7.79,7.79-7.79,7.79,3.5,7.79,7.79-3.5,7.79-7.79,7.79ZM34.48,19.64c-1.02,0-1.85-.83-1.85-1.85s.83-1.85,1.85-1.85,1.86.83,1.86,1.85-.83,1.85-1.86,1.85Z"/>
              </g>
            </svg>
        </a>
        <a :href="linkYT" target="_blank" :class="'text-btn-'+mainClass">
            <svg style="width: 34px; height: 34px; margin-right: 7px;" id="Capa_3" data-name="Capa 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52.16 52.16">
              <g id="Capa_3-2" data-name="Capa 1">
                <path fill="currentColor" d="M32.36,26.75l-8.58,4.25c-.34.18-1.48-.06-1.48-.44v-8.72c0-.39,1.15-.63,1.49-.44l8.21,4.47c.34.2.71.69.36.88ZM52.16,26.08c0,14.4-11.68,26.08-26.08,26.08S0,40.49,0,26.08,11.68,0,26.08,0s26.08,11.68,26.08,26.08ZM43.62,21.63c0-4.13-3.35-7.48-7.48-7.48h-19.14c-4.13,0-7.48,3.35-7.48,7.48v8.91c0,4.13,3.35,7.48,7.48,7.48h19.14c4.13,0,7.48-3.35,7.48-7.48v-8.91Z"/>
              </g>
            </svg>
        </a>
        <a :href="linkTK" target="_blank" :class="'text-btn-'+mainClass">
            <svg style="width: 34px; height: 34px; margin-right: 7px;" id="Capa_4" data-name="Capa 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52.2 52.2">
              <g id="Capa_4_4" data-name="Capa 1">
                <g>
                  <circle fill="currentColor" cx="26.1" cy="26.1" r="26.1"/>
                  <path style="fill: #ff1753; opacity: .8;" d="M34.74,20.92c2.33,1.66,5.19,2.65,8.27,2.65v-5.93c-.58,0-1.17-.06-1.74-.18v4.67c-3.08,0-5.94-.98-8.27-2.65v12.1c0,6.05-4.91,10.96-10.97,10.96-2.26,0-4.36-.68-6.11-1.85,1.99,2.04,4.77,3.3,7.84,3.3,6.06,0,10.97-4.91,10.97-10.96v-12.1h0ZM36.89,14.94c-1.19-1.3-1.97-2.98-2.14-4.84v-.76h-1.65c.41,2.36,1.83,4.38,3.79,5.6h0ZM19.77,36.04c-.67-.87-1.02-1.94-1.02-3.04,0-2.77,2.25-5.01,5.02-5.01.52,0,1.03.08,1.52.23v-6.06c-.58-.08-1.16-.11-1.74-.1v4.72c-.49-.16-1.01-.24-1.52-.24-2.77,0-5.02,2.25-5.02,5.01,0,1.96,1.12,3.65,2.76,4.48Z"/>
                  <path style="fill: #ffffff;" d="M33.01,19.48c2.33,1.67,5.19,2.65,8.27,2.65v-4.67c-1.72-.37-3.24-1.27-4.39-2.52-1.96-1.22-3.37-3.24-3.79-5.6h-4.32v23.69c0,2.76-2.25,5-5.02,5-1.63,0-3.08-.78-3.99-1.98-1.64-.83-2.76-2.52-2.76-4.48,0-2.77,2.25-5.01,5.02-5.01.53,0,1.04.08,1.52.24v-4.72c-5.95.12-10.74,4.98-10.74,10.96,0,2.98,1.19,5.69,3.13,7.66,1.75,1.17,3.85,1.85,6.11,1.85,6.06,0,10.97-4.91,10.97-10.96v-12.1Z"/>
                  <path style="fill: #00c9d0;" d="M41.28,17.46v-1.26c-1.55,0-3.07-.43-4.39-1.25,1.17,1.28,2.7,2.16,4.39,2.52ZM33.1,9.34c-.04-.23-.07-.45-.09-.68v-.76h-5.97v23.69c0,2.76-2.25,5-5.02,5-.81,0-1.58-.19-2.26-.53.92,1.2,2.36,1.98,3.99,1.98,2.76,0,5.01-2.24,5.02-5V9.34h4.32ZM23.55,22.07v-1.34c-.5-.07-1-.1-1.51-.1-6.06,0-10.97,4.91-10.97,10.96,0,3.8,1.93,7.14,4.86,9.11-1.93-1.98-3.13-4.68-3.13-7.66,0-5.98,4.79-10.84,10.74-10.96h0Z"/>
                </g>
              </g>
            </svg>
        </a>
      </div>
    </div>
    <!--
    <iframe src="http://localhost:8080/" width="1199" height="450"></iframe>
  
    <iframe src="http://localhost:8080/" width="430" height="450"></iframe>
    -->
    <div v-if="!iframe" id="appp" class="row mb-10 bienvenido">
      <div class="col-12 text-center">
        <h1>Tu mejor viaje <br>Bienvenido</h1>
      </div>
    </div>
    <div class="pt-0 mb-10 mt-0">
      <div class="flex justify-center place-items-center text-center" :class="sencilloredondo">
        <div
          class="switch-button"
          id="switch-button"
          @click="click()"
          :class="['largo', 'before:!bg-'+(iframe ? 'iframe-' : '')+'btn-'+mainClass]"
        >
          <div
            class="switch-item"
            @click="
              clickRedondo();
              hide();
            "
          >
            Redondo
          </div>
          <div
            class="switch-item"
            @click="
              clickSencillo();
              hide();
            "
          >
            Sencillo
          </div>
        </div>
      </div>
    </div>

    <div class="container" :class="origenVariable" data-app>
      <div class="vamos text-left">
        <h4 :class="vamosVariable" class="mx-auto max-w-[580px]">¿A dónde vamos?</h4>
      </div>
      <div class="text-center mt-0">
      <div class="box mx-auto">
        <div class="origen">
          <h5>Origen</h5>
        </div>
        <div class="input1">
          <v-container fluid>
            <v-row>
              <v-col class="d-flex" cols="" sm="13">
                <select v-model="selectida" class="icon">
                  <option disabled value="">Selecciona un origen</option>
                  <option
                    v-for="item in ida"
                    :key="item.id2"
                    :value="[
                      item.id,
                      item.attributes.nombre,
                      item.attributes.ciudad.attributes.nombre,
                      item.attributes.abreviatura,
                    ]"
                  >
                    <template v-if="item.terminal != undefined">
                      {{ item.terminal }}
                    </template>
                    <template v-else>
                      {{ item.attributes.ciudad.attributes.nombre }}
                    </template>
                  </option>
                </select>
              </v-col>
            </v-row>
          </v-container>
        </div>
        <div class="hr">
          <hr />
        </div>
        <div class="Destino">
          <h5>Destino</h5>
        </div>
        <div class="input1">
          <v-container fluid>
            <v-row align="center">
              <v-col class="d-flex" cols="" sm="14">
                <select v-model="selectvuelta" class="icon">
                  <option disabled value="">Selecciona un destino</option>
                  <option
                    v-for="item in ida"
                    :key="item.id"
                    :value="[
                      item.id,
                      item.attributes.nombre,
                      item.attributes.ciudad.attributes.nombre,
                      item.attributes.abreviatura,
                    ]"
                  >
                    <template v-if="item.terminal != undefined">
                      {{ item.terminal }}
                    </template>
                    <template v-else>
                      {{ item.attributes.ciudad.attributes.nombre }}
                    </template>
                  </option>
                </select>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </div>
    </div>
    </div>

    <div class="grid grid-cols-8">
      <div class="col-start-4 2xl:-mr-2 xl:mr-6 lg:-ml-32 -ml-48">
        <date-picker
        id="input-ida"
        v-model="date"
        name="fecha_ida"
        value-type="date"
        :lang="lang"
        placeholder="Ida"
        :disabled-date="notBeforeToday"
        format="YYYY-MM-DD"
        :confirm="false"
        :confirm-text="'ACEPTAR'"
        popup-class='translate-x-12 sm:translate-x-0'
      >
        <i slot="icon-calendar">
          <div class="icon-calendario" :class="'text-'+(iframe ? 'iframe-' : '')+'btn-'+mainClass">
            <svg style="width: 24px; height: 24px;" id="Cal_1" data-name="Capa 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.79 51.79">
              <g id="cal_1-2" data-name="Capa 1">
                <g>
                  <path  d="M39.24,0h4.05v4.05c.91,0,1.75-.03,2.58,0,1.93.07,3.49.89,4.68,2.41.68.87,1,1.89,1.23,2.94v37.02c-.03.08-.07.15-.08.23-.61,3.13-2.98,5.12-6.14,5.12-13.11,0-26.22,0-39.34,0-3.58,0-6.22-2.65-6.22-6.24C0,33.8,0,22.05,0,10.3c0-.52.05-1.05.17-1.55.68-2.86,3.06-4.7,6.08-4.71.74,0,1.47,0,2.24,0V0h4.05v4.01h26.7V0ZM4.05,19.04v.58c0,8.56,0,17.12,0,25.69,0,1.68.76,2.43,2.44,2.43,12.94,0,25.89,0,38.83,0,1.65,0,2.42-.76,2.42-2.4,0-8.58,0-17.16,0-25.74v-.56H4.05ZM47.72,14.94c0-1.72.04-3.42-.02-5.12-.03-.83-.7-1.56-1.53-1.65-.94-.1-1.9-.02-2.89-.02v3.95h-4.05v-3.99H12.54v3.98h-4.05v-4.01c-.76,0-1.48,0-2.2,0-1.41,0-2.23.82-2.24,2.23,0,1.4,0,2.8,0,4.2,0,.14.02.29.03.43h43.64Z"/>
                  <path d="M11.71,23.29v3.98h-3.99v-3.98h3.99Z"/>
                  <path d="M15.8,23.28h3.99v4h-3.99v-4Z"/>
                  <path d="M23.89,27.27v-3.98h3.98v3.98h-3.98Z"/>
                  <path d="M31.99,27.28v-3.99h3.98v3.99h-3.98Z"/>
                  <path d="M40.09,23.28h3.98v3.98h-3.98v-3.98Z"/>
                  <path d="M7.72,31.38h3.98v3.98h-3.98v-3.98Z"/>
                  <path d="M15.8,35.36v-3.98h4v3.98h-4Z"/>
                  <path d="M23.89,35.36v-3.98h3.98v3.98h-3.98Z"/>
                  <path d="M35.97,35.38h-3.98v-3.98h3.98v3.98Z"/>
                  <path d="M44.08,31.38v3.98h-3.99v-3.98h3.99Z"/>
                  <path d="M11.71,39.48v3.98h-3.98v-3.98h3.98Z"/>
                  <path d="M19.8,43.47h-3.99v-4h3.99v4Z"/>
                  <path d="M27.88,43.47h-3.98v-3.98h3.98v3.98Z"/>
                  <path d="M35.98,39.48v3.99h-3.98v-3.99h3.98Z"/>
                </g>
              </g>
            </svg>
          </div>
        </i>
      </date-picker>
      </div>
      <div class="2xl:ml-8 xl:ml-2 lg:ml-0 -ml-12" :class="pickerVueltaVariable" id="myDIV">
        <date-picker
          id="input-vuelta"
          v-model="date2"
          name="fecha_vuelta"
          value-type="date"
          :lang="lang"
          placeholder="Vuelta"
          :disabled-date="notBeforeToday"  
          :confirm="false"
          :confirm-text="'ACEPTAR'"
        >
          <i slot="icon-calendar">
            <div class="icon-calendario" :class="'text-'+(iframe ? 'iframe-' : '')+'btn-'+mainClass">
                <svg style="width: 24px; height: 24px;" id="Cal_1" data-name="Capa 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.79 51.79">
                  <g id="cal_1-2" data-name="Capa 1">
                    <g>
                      <path  d="M39.24,0h4.05v4.05c.91,0,1.75-.03,2.58,0,1.93.07,3.49.89,4.68,2.41.68.87,1,1.89,1.23,2.94v37.02c-.03.08-.07.15-.08.23-.61,3.13-2.98,5.12-6.14,5.12-13.11,0-26.22,0-39.34,0-3.58,0-6.22-2.65-6.22-6.24C0,33.8,0,22.05,0,10.3c0-.52.05-1.05.17-1.55.68-2.86,3.06-4.7,6.08-4.71.74,0,1.47,0,2.24,0V0h4.05v4.01h26.7V0ZM4.05,19.04v.58c0,8.56,0,17.12,0,25.69,0,1.68.76,2.43,2.44,2.43,12.94,0,25.89,0,38.83,0,1.65,0,2.42-.76,2.42-2.4,0-8.58,0-17.16,0-25.74v-.56H4.05ZM47.72,14.94c0-1.72.04-3.42-.02-5.12-.03-.83-.7-1.56-1.53-1.65-.94-.1-1.9-.02-2.89-.02v3.95h-4.05v-3.99H12.54v3.98h-4.05v-4.01c-.76,0-1.48,0-2.2,0-1.41,0-2.23.82-2.24,2.23,0,1.4,0,2.8,0,4.2,0,.14.02.29.03.43h43.64Z"/>
                      <path d="M11.71,23.29v3.98h-3.99v-3.98h3.99Z"/>
                      <path d="M15.8,23.28h3.99v4h-3.99v-4Z"/>
                      <path d="M23.89,27.27v-3.98h3.98v3.98h-3.98Z"/>
                      <path d="M31.99,27.28v-3.99h3.98v3.99h-3.98Z"/>
                      <path d="M40.09,23.28h3.98v3.98h-3.98v-3.98Z"/>
                      <path d="M7.72,31.38h3.98v3.98h-3.98v-3.98Z"/>
                      <path d="M15.8,35.36v-3.98h4v3.98h-4Z"/>
                      <path d="M23.89,35.36v-3.98h3.98v3.98h-3.98Z"/>
                      <path d="M35.97,35.38h-3.98v-3.98h3.98v3.98Z"/>
                      <path d="M44.08,31.38v3.98h-3.99v-3.98h3.99Z"/>
                      <path d="M11.71,39.48v3.98h-3.98v-3.98h3.98Z"/>
                      <path d="M19.8,43.47h-3.99v-4h3.99v4Z"/>
                      <path d="M27.88,43.47h-3.98v-3.98h3.98v3.98Z"/>
                      <path d="M35.98,39.48v3.99h-3.98v-3.99h3.98Z"/>
                    </g>
                  </g>
                </svg>
              </div>
          </i>
        </date-picker>
      </div>
    </div>
    <!--

    <div class="mt-5" :class="pickersVariable">
      <v-row>
          <date-picker
          id="input-ida"
          v-model="date"
          name="fecha_ida"
          value-type="date"
          :lang="lang"
          placeholder="Ida"
          :disabled-date="notBeforeToday"
          format="YYYY-MM-DD"
        >
          <i slot="icon-calendar">
            <div class="icon-calendario">
              <img src="img/Calendario.png" />
            </div>
          </i>
        </date-picker>
        <div :class="pickerVueltaVariable" id="myDIV">
          <date-picker
            id="input-vuelta"
            v-model="date2"
            name="fecha_vuelta"
            value-type="date"
            :lang="lang"
            placeholder="Vuelta"
            :disabled-date="notBeforeToday"  
          >
            <i slot="icon-calendar">
              <div class="icon-calendario">
                <img src="img/Calendario.png" />
              </div>
            </i>
          </date-picker>
        </div>
      </v-row>
    </div>
    -->
    <!--
    <div class="pasajeros">
      <br>
      <PasajeroCount />
    </div>
    -->
    <button
    class="mt-4"
      @click="
        validacion();
      "
      type="button" style="cursor: pointer !important;"
    >
      <App-button buttonText="Buscar   " />
    </button>
    <div class="alert alert-danger" role="alert" v-if="error">
      {{ error_msg }}
    </div>
    <div v-if="!iframe" class="registrate">
      <router-link v-if="noSesion" to="registrate">
        <h4>Regístrate</h4>
      </router-link>
      <router-link v-if="noSesion" to="login">
        <h4>Inicia Sesión</h4>
      </router-link>
    </div>
  </div>
</template>

<style scoped lang="less">
@import url("https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800&display=swap");

@media screen and (max-width: 430px) {
  .vamos2{
    margin-bottom: -9% !important;
    margin-top: -2% !important;
    color: white !important;
  }
  .origenDestino2{
    margin-top: -3% !important;
  }
  .idaVuelta2{
    margin-bottom: 15px !important;
    margin-top: 25px !important;
    margin-left: 3% !important;
  }
  .vuelta2{
    margin-top: 0px !important;
    margin-left: -60px !important;
  }
  .sencilloredondo2{
    margin-left: 0% !important;
    margin-top: 2.5% !important;
    margin-bottom: 5% !important;
    padding-top: 22px !important;
  }
  .bienvenido{
    margin-bottom: 5% !important;
  }
  .origenDestino{
    margin-top: -3% !important;
    /*margin-left: 1% !important;*/
  }
  .sencilloredondo{
    margin-right: 0% !important;
  }
  .idaVuelta{
    margin-left: -11% !important;
  }
  .switch-button {
    //margin-top: 5%;
    box-shadow: 1px 2px 3px;
    //margin-left: 20%;
    position: absolute;
    overflow: hidden;
    cursor: pointer;
    background: #f8fafc;
    display: flex;
    align-items: center;
    border-radius: 0.7rem;
  }
  .switch-button:before {
    content: "";
    position: absolute;
    cursor: pointer;
    left: -50%;
    top: -100%;
    height: 300%;
    width: 100%;
    border-radius: 47%;
  }
  .switch-item {
    position: relative;
    font-size: 16px;
    padding: 1.5rem;
    color: #aba6a9;
    font-weight: 500;
    cursor: pointer;
  }

  .switch-item:first-child {
    color: rgb(255, 255, 255);
  }
  .switch-button.switch-active .switch-item:first-child {
    font-size: 16px;
    color: #aba6a9;
  }
  .switch-button.switch-active .switch-item:last-child {
    color: #fff;
  }

  .switch-button.switch-active:before {
    left: 50%;
  }
  .vuelta {
    margin-left: -80%;
  }

  .largo {
    height: 2.5rem;
    width: 220px;
  }
  .ancho {
    height: 2.7rem;
    width: 280px;
    padding: 5px;
    margin-left: 10%;
  }
  #appp {
    font-family: "Montserrat";
    font-size: 24px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333333;
    font-weight: 600;
  }
  .container {
    margin: 0px auto;
  }

  .container button {
    font-size: 15px;
    padding: 2px 28px;
    background-color: #822c30;
    color: #fff;
    border: 1px solid #822c30;
    border-radius: 10px;
    cursor: pointer;
  }
  .container button.selected {
    background-color: #3a9bcf;
    border-color: rgb(141, 22, 22);
  }
  p {
    padding: 0px;
    font-size: 15px;
    width: 150%;
    background-color: rgba(250, 248, 248);
    border: 0px;
    outline: 0px;
  }

  h5 {
    margin: 30px 0 0;
    font-size: 14px;
  }

  h3 {
    font-weight: 500;
    font-family: "Montserrat";
    margin: 30px 0 0;
    font-size: 60%;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
  }
  .vamos {
    font-family: "Montserrat";
    font-weight: 500;
    //margin-right: 24%;
    //margin-top: 21%;
  }
  .box {
    box-shadow: -0.5px 0.5px 0.5px 0.5px rgba(208, 215, 230, 255);
    border-radius: 10px;
   //margin-left: 15%;
    height: 130px;
    width: 100%;
    background-color: #f8fafc;
    //margin-top: -5%;
  }
  .origen {
    font-family: "Montserrat";
    color: #989295;
    font-weight: 500;
    margin-right: 70%;
  }
  .icon {
    width: 280px;
    font-family: "Montserrat";
    font-weight: 500;
    background-color: red;
    padding-left: 15%;
    background: url("https://i.ibb.co/rbTBWwM/Camioncito-2x.png") no-repeat left;
    background-size: 30px;
  }
  .input1 {
    width: 1%;

    font-size: 60%;
  }
  input {
    width: 10%;
    height: 17px;
  }

  input::placeholder {
    font-weight: 500;
    color: #414242;
  }
  hr {
    border-top: 1px solid #a09a9e;
  }
  .d-flex {
    padding-left: 20px;
  }
  .Destino {
    font-family: "Montserrat";
    margin-top: -10%;
    color: #989295;
    font-weight: 500;
    margin-right: 70%;
  }
  .registrate {
    font-family: "Montserrat";
    font-weight: 500;
    font-size: 66%;
  }
}
@media screen and (min-width: 431px) and (max-width: 768px) {
  .vamos2{
    margin-bottom: 3% !important;
    color:#F7FAFC !important;
  }
  .origenDestino2{
    margin-top: -3% !important;
  }
  .idaVuelta2{
    margin-top: 1% !important;
    margin-left: 13% !important;
  }
  .vuelta2{
    margin-left: -3%;
  }
  .bienvenido{
    margin-bottom: 5% !important;
  }
  .switch-button {
    //margin-top: 5%;
    box-shadow: 1px 2px 3px;
    //margin-left: 20%;
    position: absolute;
    overflow: hidden;
    cursor: pointer;
    background: #f8fafc;
    display: flex;
    align-items: center;
    border-radius: 0.7rem;
  }
  .switch-button:before {
    content: "";
    position: absolute;
    cursor: pointer;
    left: -50%;
    top: -100%;
    height: 300%;
    width: 100%;
    border-radius: 47%;
  }
  .switch-item {
    position: relative;
    font-size: 16px;
    padding: 1.5rem;
    color: #aba6a9;
    font-weight: 500;
    cursor: pointer;
  }

  .switch-item:first-child {
    color: rgb(255, 255, 255);
  }
  .switch-button.switch-active .switch-item:first-child {
    font-size: 16px;
    color: #aba6a9;
  }
  .switch-button.switch-active .switch-item:last-child {
    color: #fff;
  }

  .switch-button.switch-active:before {
    left: 50%;
  }
  .vuelta {
    margin-left: -16%;
  }

  .largo {
    height: 2.5rem;
    width: 220px;
  }
  .ancho {
    height: 2.7rem;
    width: 280px;
    padding: 5px;
    margin-left: 10%;
  }
  #appp {
    font-family: "Montserrat";
    font-size: 24px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333333;
    font-weight: 600;
  }
  .container {
    margin: 0px auto;
  }

  .container button {
    font-size: 15px;
    padding: 2px 28px;
    background-color: #822c30;
    color: #fff;
    border: 1px solid #822c30;
    border-radius: 10px;
    cursor: pointer;
  }
  .container button.selected {
    background-color: #3a9bcf;
    border-color: rgb(141, 22, 22);
  }
  p {
    padding: 0px;
    font-size: 15px;
    width: 150%;
    background-color: rgba(250, 248, 248);
    border: 0px;
    outline: 0px;
  }

  h5 {
    margin: 30px 0 0;
    font-size: 14px;
  }

  h3 {
    font-weight: 500;
    font-family: "Montserrat";
    margin: 30px 0 0;
    font-size: 60%;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
  }
  .vamos {
    font-family: "Montserrat";
    font-weight: 500;
    //margin-right: 24%;
    //margin-top: 21%;
  }
  .box {
    box-shadow: -0.5px 0.5px 0.5px 0.5px rgba(208, 215, 230, 255);
    border-radius: 10px;
    //margin-left: 15%;
    height: 130px;
    width: 100%;
    background-color: #f8fafc;
    //margin-top: -5%;
  }
  .origen {
    font-family: "Montserrat";
    color: #989295;
    font-weight: 500;
    margin-right: 70%;
  }
  .icon {
    width: 280px;
    font-family: "Montserrat";
    font-weight: 500;
    background-color: red;
    padding-left: 15%;
    background: url("https://i.ibb.co/rbTBWwM/Camioncito-2x.png") no-repeat left;
    background-size: 30px;
  }
  .input1 {
    width: 1%;

    font-size: 60%;
  }
  input {
    width: 10%;
    height: 17px;
  }

  input::placeholder {
    font-weight: 500;
    color: #414242;
  }
  hr {
    border-top: 1px solid #a09a9e;
  }
  .d-flex {
    padding-left: 20px;
  }
  .Destino {
    font-family: "Montserrat";
    margin-top: -10%;
    color: #989295;
    font-weight: 500;
    margin-right: 70%;
  }
  .registrate {
    font-family: "Montserrat";
    font-weight: 500;
    font-size: 66%;
  }
}
@media screen and (min-width: 769px) and (max-width: 992px) {
  .vamos2{
    margin-bottom: 1% !important;
    color:#F7FAFC !important;
  }
  .origenDestino2{
    margin-top: -3% !important;
  }
  .idaVuelta2{
    margin-top: 1% !important;
    margin-left: 13% !important;
  }
  .vuelta2{
    margin-left: -3%;
  }
  .bienvenido{
    margin-bottom: 5% !important;
  }
  .origenDestino{
    margin-top: 7% !important;
    /*margin-left: 10% !important;*/
  }
  .idaVuelta{
    margin-top: 3% !important;
    margin-left: 10% !important;
  }

  #appp {
    font-family: "Montserrat";
    font-size: 24px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333333;
    font-weight: 600;
  }
  .switch-button {
    //margin-top: 5%;
    box-shadow: 1px 2px 3px;
    //margin-left: 20%;
    position: absolute;
    overflow: hidden;
    cursor: pointer;

    background: #f8fafc;
    display: flex;

    align-items: center;
    border-radius: 0.7rem;
  }
  .switch-button:before {
    content: "";
    position: absolute;
    cursor: pointer;
    left: -50%;
    top: -100%;
    height: 300%;
    width: 100%;
    border-radius: 47%;
  }
  .switch-item {
    position: relative;
    font-size: 16px;
    padding: 1.5rem;
    color: #aba6a9;
    font-weight: 500;
    cursor: pointer;
  }
  .switch-item:first-child {
    color: rgb(255, 255, 255);
  }
  .switch-button.switch-active .switch-item:first-child {
    font-size: 16px;
    color: #aba6a9;
  }
  .switch-button.switch-active .switch-item:last-child {
    color: #fff;
  }
  .switch-button.switch-active:before {
    left: 50%;
  }

  .largo {
    height: 2.5rem;
    width: 220px;
  }
  .ancho {
    height: 2.7rem;
    width: 280px;
    padding: 5px;
    margin-left: 10%;
  }
  .container {
    margin: 0px auto;
  }

  .container button {
    font-size: 15px;
    padding: 2px 28px;
    background-color: #822c30;
    color: #fff;
    border: 1px solid #822c30;
    border-radius: 10px;
    cursor: pointer;
  }
  .container button.selected {
    background-color: #3a9bcf;
    border-color: rgb(141, 22, 22);
  }
  p {
    padding: 0px;
    font-size: 15px;
    width: 150%;
    background-color: rgba(250, 248, 248);
    border: 0px;
    outline: 0px;
  }

  h5 {
    margin: 30px 0 0;
    font-size: 14px;
  }

  h3 {
    font-weight: 500;
    font-family: "Montserrat";
    margin: 30px 0 0;
    font-size: 60%;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  .vamos {
    font-family: "Montserrat";
    font-size: 16px;
    font-weight: 600;
    //margin-right: 47%;
    //margin-top: 15%;
  }
  .box {
    box-shadow: -0.5px 0.5px 0.5px 0.5px rgba(208, 215, 230, 255);
    border-radius: 10px;
    height: 135px;
    width: 85%;
    background-color: #f8fafc;
    //margin-top: -5%;
  }
  .origen {
    font-family: "Montserrat";
    color: #989295;
    font-weight: 500;
    margin-right: 70%;
  }
  .icon {
    width: 320px;
    margin-left: 2%;
    font-family: "Montserrat";
    font-weight: 500;

    background-color: red;

    padding-left: 12%;
    background: url("https://i.ibb.co/rbTBWwM/Camioncito-2x.png") no-repeat left;
    background-size: 24px;
  }
  .input1 {
    width: 20%;
    font-size: 60%;
  }

  input {
    width: 480%;
    height: 18px;
  }

  input::placeholder {
    font-weight: 500;
    color: #414242;
  }
  hr {
    border-top: 1px solid #a09a9e;
  }
  .Destino {
    font-family: "Montserrat";
    margin-top: -6%;
    color: #989295;
    font-weight: 500;
    margin-right: 70%;
  }
  .vuelta {
    margin-left: -px;
  }
  .registrate {
    font-family: "Montserrat";
    font-weight: 500;
    font-size: 66%;
  }
  .d-flex {
    margin-left: 20%;
  }
}
@media screen and (min-width: 993px) and (max-width: 1023px) {
  .vamos2{
    margin-bottom: -1% !important;
    color:#F7FAFC !important;
  }
  .origenDestino{
    margin-top: 3% !important;
    /*margin-left: 19% !important;*/
  }
  .idaVuelta{
    margin-top: 0% !important;
    margin-left: 10% !important;
  }
  .vuelta{
    margin-left: 3%;
  }
  .origenDestino2{
    margin-top: 3% !important;
  }
  .idaVuelta2{
    margin-top: 0% !important;
    margin-left: 10% !important;
  }
  .vuelta2{
    margin-left: 3%;
  }
  .sencilloredondo2{
    margin-right: 20% !important;
  }
  .sencilloredondo{
    margin-right: 22% !important;
  }
  #appp {
    margin-top: 8%;
    margin-left: -40px;
    font-family: "Montserrat";
    font-size: 26px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    color: #333333;
    font-weight: 600;
  }
  .switch-button {
    margin-top: 5%;
    box-shadow: 1px 2px 3px;
    margin-left: 20%;
    position: absolute;
    overflow: hidden;
    cursor: pointer;

    background: #f8fafc;
    display: flex;

    align-items: center;
    border-radius: 0.7rem;
  }
  .switch-button:before {
    content: "";
    position: absolute;
    cursor: pointer;
    left: -50%;
    top: -100%;
    height: 300%;
    width: 100%;
    border-radius: 47%;
  }
  .switch-item {
    position: relative;
    font-size: 16px;
    padding: 1.5rem;
    color: #aba6a9;
    font-weight: 500;
    cursor: pointer;
  }
  .switch-item:first-child {
    color: rgb(255, 255, 255);
  }
  .switch-button.switch-active .switch-item:first-child {
    font-size: 16px;
    color: #aba6a9;
  }
  .switch-button.switch-active .switch-item:last-child {
    color: #fff;
  }

  .switch-button.switch-active:before {
    left: 50%;
  }

  .largo {
    height: 2.5rem;
    width: 220px;
  }
  .ancho {
    height: 2.7rem;
    width: 280px;
    padding: 5px;
    margin-left: 10%;
  }
  .container {
    margin: 1px auto;
  }

  .container button {
    font-size: 15px;
    padding: 2px 28px;
    background-color: #822c30;
    color: #fff;
    border: 1px solid #822c30;
    border-radius: 10px;
    cursor: pointer;
  }
  .container button.selected {
    background-color: #3a9bcf;
    border-color: rgb(141, 22, 22);
  }

  p {
    padding: 0px;
    font-size: 15px;
    width: 150%;
    background-color: rgba(250, 248, 248);
    border: 0px;
    outline: 0px;
  }

  h5 {
    margin: 30px 0 0;
    font-size: 16px;
  }

  h3 {
    font-weight: 500;
    font-family: "Montserrat";
    margin: 30px 0 0;
    font-size: 90%;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }

  .vamos {
    font-family: "Montserrat";
    font-size: 16px;
    font-weight: 600;
    //margin-right: 25%;
    //margin-top: 15%;
  }
  .box {
    box-shadow: -0.5px 0.5px 0.5px 0.5px rgba(208, 215, 230, 255);
    border-radius: 10px;
    height: 135px;
    width: 580px;
    background-color: #f8fafc;
    //margin-top: -2%;
  }
  .origen {
    font-family: "Montserrat";
    color: #989295;
    font-weight: 500;
    margin-right: 70%;
  }
  .Destino {
    font-family: "Montserrat";
    margin-top: -5%;
    color: #989295;
    font-weight: 500;
    margin-right: 70%;
  }
  .icon {
    margin-left: 20%;
    font-family: "Montserrat";
    font-weight: 500;
    background-color: red;

    padding-left: 19%;
    background: url("https://i.ibb.co/rbTBWwM/Camioncito-2x.png") no-repeat left;
    background-size: 24px;
  }
  .input1 {
    width: 20%;
    font-size: 60%;
  }

  input {
    width: 480%;
    height: 18px;
  }

  input::placeholder {
    font-weight: 500;
    color: #414242;
  }
  hr {
    border-top: 1px solid #a09a9e;
  }
  .registrate {
    font-family: "Montserrat";
    font-weight: 500;
  }
}
@media screen and (min-width: 1024px) and (max-width: 1199px) {
  .vamos2{
    margin-bottom: 0% !important;
    margin-top: 1% !important;
    color:#F7FAFC !important;
  }
  .origenDestino{
    margin-top: 3% !important;
    /*margin-left: 19% !important;*/
  }
  .idaVuelta{
    margin-top: 0% !important;
    margin-left: 10% !important;
  }
  .vuelta{
    margin-left: 3%;
  }
  .origenDestino2{
    margin-top: 3% !important;
  }
  .idaVuelta2{
    margin-top: 0% !important;
    margin-left: 10% !important;
  }
  .vuelta2{
    margin-left: 3%;
  }
  .sencilloredondo2{
    margin-right: 20% !important;
  }
  .sencilloredondo{
    margin-right: 22% !important;
  }
  #appp {
    margin-top: 8%;
    margin-left: -40px;
    font-family: "Montserrat";
    font-size: 26px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    color: #333333;
    font-weight: 600;
  }
  .switch-button {
    margin-top: 5%;
    box-shadow: 1px 2px 3px;
    margin-left: 20%;
    position: absolute;
    overflow: hidden;
    cursor: pointer;

    background: #f8fafc;
    display: flex;

    align-items: center;
    border-radius: 0.7rem;
  }
  .switch-button:before {
    content: "";
    position: absolute;
    cursor: pointer;
    left: -50%;
    top: -100%;
    height: 300%;
    width: 100%;
    border-radius: 47%;
  }
  .switch-item {
    position: relative;
    font-size: 16px;
    padding: 1.5rem;
    color: #aba6a9;
    font-weight: 500;
    cursor: pointer;
  }
  .switch-item:first-child {
    color: rgb(255, 255, 255);
  }
  .switch-button.switch-active .switch-item:first-child {
    font-size: 16px;
    color: #aba6a9;
  }
  .switch-button.switch-active .switch-item:last-child {
    color: #fff;
  }

  .switch-button.switch-active:before {
    left: 50%;
  }

  .largo {
    height: 2.5rem;
    width: 220px;
  }
  .ancho {
    height: 2.7rem;
    width: 280px;
    padding: 5px;
    margin-left: 10%;
  }
  .container {
    margin: 1px auto;
  }

  .container button {
    font-size: 15px;
    padding: 2px 28px;
    background-color: #822c30;
    color: #fff;
    border: 1px solid #822c30;
    border-radius: 10px;
    cursor: pointer;
  }
  .container button.selected {
    background-color: #3a9bcf;
    border-color: rgb(141, 22, 22);
  }

  p {
    padding: 0px;
    font-size: 15px;
    width: 150%;
    background-color: rgba(250, 248, 248);
    border: 0px;
    outline: 0px;
  }

  h5 {
    margin: 30px 0 0;
    font-size: 16px;
  }

  h3 {
    font-weight: 500;
    font-family: "Montserrat";
    margin: 30px 0 0;
    font-size: 90%;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }

  .vamos {
    font-family: "Montserrat";
    font-size: 16px;
    font-weight: 600;
    //margin-right: 25%;
    //margin-top: 15%;
    margin-left: 20px;
  }
  .box {
    box-shadow: -0.5px 0.5px 0.5px 0.5px rgba(208, 215, 230, 255);
    border-radius: 10px;
    height: 135px;
    width: 580px;
    background-color: #f8fafc;
    //margin-top: -2%;
  }
  .origen {
    font-family: "Montserrat";
    color: #989295;
    font-weight: 500;
    margin-right: 70%;
  }
  .Destino {
    font-family: "Montserrat";
    margin-top: -5%;
    color: #989295;
    font-weight: 500;
    margin-right: 70%;
  }
  .icon {
    margin-left: 20%;
    font-family: "Montserrat";
    font-weight: 500;
    background-color: red;

    padding-left: 19%;
    background: url("https://i.ibb.co/rbTBWwM/Camioncito-2x.png") no-repeat left;
    background-size: 24px;
  }
  .input1 {
    width: 20%;
    font-size: 60%;
  }

  input {
    width: 480%;
    height: 18px;
  }

  input::placeholder {
    font-weight: 500;
    color: #414242;
  }
  hr {
    border-top: 1px solid #a09a9e;
  }
  .registrate {
    font-family: "Montserrat";
    font-weight: 500;
  }
}
@media screen and (min-width: 1200px) {
  .vamos2{
    margin-bottom: -3% !important;
    color:#F7FAFC !important;
  }
  .origenDestino2{
    margin-top: 2% !important;
  }
  .idaVuelta2{
    margin-top: 0% !important;
    margin-left: 17% !important;
    margin-bottom: -2% !important;
  }
  .vuelta2{
    margin-left: -1%;
  }
  .origenDestino{
    margin-top: 7% !important;
    /*margin-left: 25% !important;*/
  }
  .idaVuelta{
    margin-top: 3% !important;
    margin-left: 25% !important;
  }
  .sencilloredondo{
    margin-right: 22% !important;
  }
  .sencilloredondo2{
    margin-right: 20% !important;
  }
  #appp {
    //margin-left: -40px;
    font-family: "Montserrat";
    font-size: 26px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333333;
    font-weight: 600;
  }
  .switch-button {
    margin-top: 5%;
    box-shadow: 1px 2px 3px;
    margin-left: 20%;
    position: absolute;
    overflow: hidden;
    cursor: pointer;

    background: #f8fafc;
    display: flex;

    align-items: center;
    border-radius: 0.7rem;
  }
  .switch-button:before {
    content: "";
    position: absolute;
    cursor: pointer;
    left: -50%;
    top: -100%;
    height: 300%;
    width: 100%;
    border-radius: 47%;
  }
  .switch-item {
    position: relative;
    font-size: 16px;
    padding: 1.5rem;
    color: #aba6a9;
    font-weight: 500;
    cursor: pointer;
  }
  .switch-item:first-child {
    color: rgb(255, 255, 255);
  }
  .switch-button.switch-active .switch-item:first-child {
    font-size: 16px;
    color: #aba6a9;
  }
  .switch-button.switch-active .switch-item:last-child {
    color: #fff;
  }

  .switch-button.switch-active:before {
    left: 50%;
  }
  .largo {
    height: 2.5rem;
    width: 220px;
  }
  .ancho {
    height: 2.7rem;
    width: 280px;
    padding: 5px;
    margin-left: 10%;
  }

  .container button {
    font-size: 15px;
    padding: 2px 28px;
    background-color: #822c30;
    color: #fff;
    border: 1px solid #822c30;
    border-radius: 10px;
    cursor: pointer;
  }
  .container button.selected {
    background-color: #3a9bcf;
    border-color: rgb(141, 22, 22);
  }
  p {
    padding: 0px;
    font-size: 25px;
    width: 150%;
    background-color: rgba(250, 248, 248);
    border: 0px;
    outline: 0px;
  }

  h5 {
    margin: 30px 0 0;
    font-size: 18px;
  }

  h3 {
    font-weight: 500;
    font-family: "Montserrat";
    margin: 30px 0 0;
    font-size: 90%;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
  }
  .vamos {
    font-family: "Montserrat";
    font-size: 26px;
    font-weight: 600;
    //margin-right: 28%;
    //margin-top: 15%;
  }
  .box {
    box-shadow: -0.5px 0.5px 0.5px 0.5px rgba(208, 215, 230, 255);
    border-radius: 10px;
    height: 135px;
    width: 580px;
    background-color: #f8fafc;
    //margin-top: -1%;
  }
  .origen {
    font-family: "Montserrat";
    color: #989295;
    font-weight: 500;
    margin-right: 72%;
  }
  .Destino {
    font-family: "Montserrat";
    margin-top: -5%;
    color: #989295;
    font-weight: 500;
    margin-right: 70%;
  }
  .icon {
    margin-left: 20%;
    font-family: "Montserrat";
    font-weight: 500;
    background-color: red;

    padding-left: 22%;
    background: url("https://i.ibb.co/rbTBWwM/Camioncito-2x.png") no-repeat left;
    background-size: 24px;
  }
  .input1 {
    width: 20%;

    font-size: 60%;
  }

  input {
    width: 480%;
    height: 18px;
  }

  input::placeholder {
    font-weight: 500;
    color: #414242;
  }
  hr {
    border-top: 1px solid #a09a9e;
  }
  .registrate {
    font-family: "Montserrat";
    font-weight: 500;
    font-size: 66%;
  }
  .pasajeros {
    margin-left: 18%;
  }
}
@media screen and (min-width: 1366px) {
  .origenDestino{
    margin-top: 7% !important;
    /*margin-left: 28% !important;*/
  }
  .idaVuelta{
    margin-top: 3% !important;
    margin-left: 24% !important;
  }
  .sencilloredondo{
    margin-right: 20% !important;
  }
  .sencilloredondo2{
    margin-right: 20% !important;
  }
  #appp {
    margin-left: -10px !important;
    font-family: "Montserrat";
    font-size: 26px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333333;
    font-weight: 600;
  }
  .switch-button {
    margin-top: 5%;
    box-shadow: 1px 2px 3px;
    margin-left: 20%;
    position: absolute;
    overflow: hidden;
    cursor: pointer;

    background: #f8fafc;
    display: flex;

    align-items: center;
    border-radius: 0.7rem;
  }
  .switch-button:before {
    content: "";
    position: absolute;
    cursor: pointer;
    left: -50%;
    top: -100%;
    height: 300%;
    width: 100%;
    border-radius: 47%;
  }
  .switch-item {
    position: relative;
    font-size: 16px;
    padding: 1.5rem;
    color: #aba6a9;
    font-weight: 500;
    cursor: pointer;
  }
  .switch-item:first-child {
    color: rgb(255, 255, 255);
  }
  .switch-button.switch-active .switch-item:first-child {
    font-size: 16px;
    color: #aba6a9;
  }
  .switch-button.switch-active .switch-item:last-child {
    color: #fff;
  }

  .switch-button.switch-active:before {
    left: 50%;
  }
  .largo {
    height: 2.5rem;
    width: 220px;
  }
  .ancho {
    height: 2.7rem;
    width: 280px;
    padding: 5px;
    margin-left: 10%;
  }

  .container button {
    font-size: 15px;
    padding: 2px 28px;
    background-color: #822c30;
    color: #fff;
    border: 1px solid #822c30;
    border-radius: 10px;
    cursor: pointer;
  }
  .container button.selected {
    background-color: #3a9bcf;
    border-color: rgb(141, 22, 22);
  }
  p {
    padding: 0px;
    font-size: 25px;
    width: 150%;
    background-color: rgba(250, 248, 248);
    border: 0px;
    outline: 0px;
  }

  h5 {
    margin: 30px 0 0;
    font-size: 18px;
  }

  h3 {
    font-weight: 500;
    font-family: "Montserrat";
    margin: 30px 0 0;
    font-size: 90%;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
  }
  .vamos {
    font-family: "Montserrat";
    font-size: 26px;
    font-weight: 600;
    //margin-right: 28%;
    //margin-top: 15%;
  }
  .box {
    box-shadow: -0.5px 0.5px 0.5px 0.5px rgba(208, 215, 230, 255);
    border-radius: 10px;
    height: 135px;
    width: 580px;
    background-color: #f8fafc;
    //margin-top: -1%;
  }
  .origen {
    font-family: "Montserrat";
    color: #989295;
    font-weight: 500;
    margin-right: 72%;
  }
  .Destino {
    font-family: "Montserrat";
    margin-top: -5%;
    color: #989295;
    font-weight: 500;
    margin-right: 70%;
  }
  .icon {
    margin-left: 20%;
    font-family: "Montserrat";
    font-weight: 500;
    background-color: red;

    padding-left: 22%;
    background: url("https://i.ibb.co/rbTBWwM/Camioncito-2x.png") no-repeat left;
    background-size: 24px;
  }
  .input1 {
    width: 20%;

    font-size: 60%;
  }

  input {
    width: 480%;
    height: 18px;
  }

  input::placeholder {
    font-weight: 500;
    color: #414242;
  }
  hr {
    border-top: 1px solid #a09a9e;
  }
  .registrate {
    font-family: "Montserrat";
    font-weight: 500;
    font-size: 66%;
  }
  .pasajeros {
    margin-left: 18%;
  }
}
@media screen and (min-width: 1440px) {
  .origenDestino{
    margin-top: 7% !important;
    /*margin-left: 29% !important;*/
  }
  .idaVuelta{
    margin-top: 3% !important;
    margin-left: 24.5% !important;
  }
  .sencilloredondo{
    margin-right: 20% !important;
  }
  .sencilloredondo2{
    margin-right: 20% !important;
  }
  #appp {
    margin-left: -10px !important;
    font-family: "Montserrat";
    font-size: 26px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333333;
    font-weight: 600;
  }
  .switch-button {
    margin-top: 5%;
    box-shadow: 1px 2px 3px;
    margin-left: 20%;
    position: absolute;
    overflow: hidden;
    cursor: pointer;

    background: #f8fafc;
    display: flex;

    align-items: center;
    border-radius: 0.7rem;
  }
  .switch-button:before {
    content: "";
    position: absolute;
    cursor: pointer;
    left: -50%;
    top: -100%;
    height: 300%;
    width: 100%;
    border-radius: 47%;
  }
  .switch-item {
    position: relative;
    font-size: 16px;
    padding: 1.5rem;
    color: #aba6a9;
    font-weight: 500;
    cursor: pointer;
  }
  .switch-item:first-child {
    color: rgb(255, 255, 255);
  }
  .switch-button.switch-active .switch-item:first-child {
    font-size: 16px;
    color: #aba6a9;
  }
  .switch-button.switch-active .switch-item:last-child {
    color: #fff;
  }

  .switch-button.switch-active:before {
    left: 50%;
  }
  .largo {
    height: 2.5rem;
    width: 220px;
  }
  .ancho {
    height: 2.7rem;
    width: 280px;
    padding: 5px;
    margin-left: 10%;
  }

  .container button {
    font-size: 15px;
    padding: 2px 28px;
    background-color: #822c30;
    color: #fff;
    border: 1px solid #822c30;
    border-radius: 10px;
    cursor: pointer;
  }
  .container button.selected {
    background-color: #3a9bcf;
    border-color: rgb(141, 22, 22);
  }
  p {
    padding: 0px;
    font-size: 25px;
    width: 150%;
    background-color: rgba(250, 248, 248);
    border: 0px;
    outline: 0px;
  }

  h5 {
    margin: 30px 0 0;
    font-size: 18px;
  }

  h3 {
    font-weight: 500;
    font-family: "Montserrat";
    margin: 30px 0 0;
    font-size: 90%;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
  }
  .vamos {
    font-family: "Montserrat";
    font-size: 26px;
    font-weight: 600;
    //margin-right: 28%;
    //margin-top: 15%;
  }
  .box {
    box-shadow: -0.5px 0.5px 0.5px 0.5px rgba(208, 215, 230, 255);
    border-radius: 10px;
    height: 135px;
    width: 580px;
    background-color: #f8fafc; 
    //margin-top: -1%;
  }
  .origen {
    font-family: "Montserrat";
    color: #989295;
    font-weight: 500;
    margin-right: 72%;
  }
  .Destino {
    font-family: "Montserrat";
    margin-top: -5%;
    color: #989295;
    font-weight: 500;
    margin-right: 70%;
  }
  .icon {
    margin-left: 20%;
    font-family: "Montserrat";
    font-weight: 500;
    background-color: red;

    padding-left: 22%;
    background: url("https://i.ibb.co/rbTBWwM/Camioncito-2x.png") no-repeat left;
    background-size: 24px;
  }
  .input1 {
    width: 20%;

    font-size: 60%;
  }

  input {
    width: 480%;
    height: 18px;
  }

  input::placeholder {
    font-weight: 500;
    color: #414242;
  }
  hr {
    border-top: 1px solid #a09a9e;
  }
  .registrate {
    font-family: "Montserrat";
    font-weight: 500;
    font-size: 66%;
  }
  .pasajeros {
    margin-left: 18%;
  }
}
@media screen and (min-width: 1536px) {
  .origenDestino{
    margin-top: 7% !important;
    /*margin-left: 29% !important;*/
  }
  .vamos2{
    margin-bottom: -2% !important;
    color:#F7FAFC !important;
  }
  .idaVuelta{
    margin-top: 3% !important;
    margin-left: 24.5% !important;
  }
  .sencilloredondo{
    margin-right: 20% !important;
  }
  .sencilloredondo2{
    margin-right: 20% !important;
  }
  #appp {
    margin-left: -10px !important;
    font-family: "Montserrat";
    font-size: 26px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333333;
    font-weight: 600;
  }
  .switch-button {
    margin-top: 5%;
    box-shadow: 1px 2px 3px;
    margin-left: 20%;
    position: absolute;
    overflow: hidden;
    cursor: pointer;

    background: #f8fafc;
    display: flex;

    align-items: center;
    border-radius: 0.7rem;
  }
  .switch-button:before {
    content: "";
    position: absolute;
    cursor: pointer;
    left: -50%;
    top: -100%;
    height: 300%;
    width: 100%;
    border-radius: 47%;
  }
  .switch-item {
    position: relative;
    font-size: 16px;
    padding: 1.5rem;
    color: #aba6a9;
    font-weight: 500;
    cursor: pointer;
  }
  .switch-item:first-child {
    color: rgb(255, 255, 255);
  }
  .switch-button.switch-active .switch-item:first-child {
    font-size: 16px;
    color: #aba6a9;
  }
  .switch-button.switch-active .switch-item:last-child {
    color: #fff;
  }

  .switch-button.switch-active:before {
    left: 50%;
  }
  .largo {
    height: 2.5rem;
    width: 220px;
  }
  .ancho {
    height: 2.7rem;
    width: 280px;
    padding: 5px;
    margin-left: 10%;
  }

  .container button {
    font-size: 15px;
    padding: 2px 28px;
    background-color: #822c30;
    color: #fff;
    border: 1px solid #822c30;
    border-radius: 10px;
    cursor: pointer;
  }
  .container button.selected {
    background-color: #3a9bcf;
    border-color: rgb(141, 22, 22);
  }
  p {
    padding: 0px;
    font-size: 25px;
    width: 150%;
    background-color: rgba(250, 248, 248);
    border: 0px;
    outline: 0px;
  }

  h5 {
    margin: 30px 0 0;
    font-size: 18px;
  }

  h3 {
    font-weight: 500;
    font-family: "Montserrat";
    margin: 30px 0 0;
    font-size: 90%;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
  }
  .vamos {
    font-family: "Montserrat";
    font-size: 26px;
    font-weight: 600;
    margin-left: 20px;
    //margin-right: 28%;
    //margin-top: 15%;
  }
  .box {
    box-shadow: -0.5px 0.5px 0.5px 0.5px rgba(208, 215, 230, 255);
    border-radius: 10px;
    height: 135px;
    width: 580px;
    background-color: #f8fafc; 
    //margin-top: -1%;
  }
  .origen {
    font-family: "Montserrat";
    color: #989295;
    font-weight: 500;
    margin-right: 72%;
  }
  .Destino {
    font-family: "Montserrat";
    margin-top: -5%;
    color: #989295;
    font-weight: 500;
    margin-right: 70%;
  }
  .icon {
    margin-left: 20%;
    font-family: "Montserrat";
    font-weight: 500;
    background-color: red;

    padding-left: 22%;
    background: url("https://i.ibb.co/rbTBWwM/Camioncito-2x.png") no-repeat left;
    background-size: 24px;
  }
  .input1 {
    width: 20%;

    font-size: 60%;
  }

  input {
    width: 480%;
    height: 18px;
  }

  input::placeholder {
    font-weight: 500;
    color: #414242;
  }
  hr {
    border-top: 1px solid #a09a9e;
  }
  .registrate {
    font-family: "Montserrat";
    font-weight: 500;
    font-size: 66%;
  }
  .pasajeros {
    margin-left: 18%;
  }
}
@media screen and (min-width: 1920px) {
  .origenDestino{
    margin-top: 7% !important;
    /*margin-left: 34% !important;*/
  }
  .origenDestino2 {
      margin-top: 2.2% !important;
  }
  .sencilloredondo2 {
    margin-right: 20% !important;
    margin-top: -9px !important;
  }
  .vamos2 {
    margin-bottom: -2% !important;
    color: #f7fafc !important;
  } 
  .idaVuelta{
    margin-top: 3% !important;
    margin-left: 28.5% !important;
  }
  .sencilloredondo{
    margin-left: 0px !important;
  }

  #appp {
    margin-left: -5px !important;
    font-family: "Montserrat";
    font-size: 26px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #333333;
    font-weight: 600;
  }
  .switch-button {
    margin-top: 5%;
    box-shadow: 1px 2px 3px;
    margin-left: 20%;
    position: absolute;
    overflow: hidden;
    cursor: pointer;

    background: #f8fafc;
    display: flex;

    align-items: center;
    border-radius: 0.7rem;
  }
  .switch-button:before {
    content: "";
    position: absolute;
    cursor: pointer;
    left: -50%;
    top: -100%;
    height: 300%;
    width: 100%;
    border-radius: 47%;
  }
  .switch-item {
    position: relative;
    font-size: 16px;
    padding: 1.5rem;
    color: #aba6a9;
    font-weight: 500;
    cursor: pointer;
  }
  .switch-item:first-child {
    color: rgb(255, 255, 255);
  }
  .switch-button.switch-active .switch-item:first-child {
    font-size: 16px;
    color: #aba6a9;
  }
  .switch-button.switch-active .switch-item:last-child {
    color: #fff;
  }

  .switch-button.switch-active:before {
    left: 50%;
  }
  .largo {
    height: 2.5rem;
    width: 220px;
  }
  .ancho {
    height: 2.7rem;
    width: 280px;
    padding: 5px;
    margin-left: 10%;
  }

  .container button {
    font-size: 15px;
    padding: 2px 28px;
    background-color: #822c30;
    color: #fff;
    border: 1px solid #822c30;
    border-radius: 10px;
    cursor: pointer;
  }
  .container button.selected {
    background-color: #3a9bcf;
    border-color: rgb(141, 22, 22);
  }
  p {
    padding: 0px;
    font-size: 25px;
    width: 150%;
    background-color: rgba(250, 248, 248);
    border: 0px;
    outline: 0px;
  }

  h5 {
    margin: 30px 0 0;
    font-size: 18px;
  }

  h3 {
    font-weight: 500;
    font-family: "Montserrat";
    margin: 30px 0 0;
    font-size: 90%;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
  }
  .vamos {
    font-family: "Montserrat";
    font-size: 26px;
    font-weight: 600;
    //margin-right: 28%;
    //margin-top: 15%;
  }
  .box {
    box-shadow: -0.5px 0.5px 0.5px 0.5px rgba(208, 215, 230, 255);
    border-radius: 10px;
    height: 135px;
    width: 580px;
    background-color: #f8fafc;
    //margin-top: -1%;
  }
  .origen {
    font-family: "Montserrat";
    color: #989295;
    font-weight: 500;
    margin-right: 72%;
  }
  .Destino {
    font-family: "Montserrat";
    margin-top: -5%;
    color: #989295;
    font-weight: 500;
    margin-right: 70%;
  }
  .icon {
    margin-left: 20%;
    font-family: "Montserrat";
    font-weight: 500;
    background-color: red;

    padding-left: 22%;
    background: url("https://i.ibb.co/rbTBWwM/Camioncito-2x.png") no-repeat left;
    background-size: 24px;
  }
  .input1 {
    width: 20%;

    font-size: 60%;
  }

  input {
    width: 480%;
    height: 18px;
  }

  input::placeholder {
    font-weight: 500;
    color: #414242;
  }
  hr {
    border-top: 1px solid #a09a9e;
  }
  .registrate {
    font-family: "Montserrat";
    font-weight: 500;
    font-size: 66%;
  }
  .pasajeros {
    margin-left: 18%;
  }
}
</style>

<script>
// @ is an alias to /src
import axios from "axios";
import Toggle2 from "@/components/Toogle2.vue";
import Calendar from "@/components/ButtonCalendar.vue";
import PasajeroCount from "@/components/PasajerosCount.vue";
import AppButton from "@/components/ButtonPrimary.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Vue from "vue";

export default {
  name: "HomeView",
  computed: {
    linkFB() {
      return process.env.VUE_APP_FB;
    },
    linkYT() {
      return process.env.VUE_APP_YT;
    },
    linkIN() {
      return process.env.VUE_APP_IN;
    },
    linkTK() {
      return process.env.VUE_APP_TK;
    },
    linea() {
      return process.env.VUE_APP_LINEA;
    },
    mainClass() {
      return process.env.VUE_APP_COLOR;
    }
  },
  props: {},
  data: () => ({
    bodyVariable: 'bodyFondo',
    vamosVariable: '#000000',
    origenVariable: 'origenDestino',
    pickersVariable: 'idaVuelta',
    pickerVueltaVariable: 'vuelta',
    sencilloredondo: 'sencilloredondo',
    iframe: false,
    ciudad_ida: [],
    ida: [],
    count: 0,
    terminal_origen_id: "",
    ida2: [],
    selectida: null,
    selectvuelta: null,
    loading: false,
    error: false,
    error_msg: "",
    date: null,
    date2: null,
    open: false,
    lang: {
      days: ["D", "L", "M", "Mi", "J", "V", "S"],
      months: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
    },
    noSesion: false
  }),
  
  async mounted() {
    this.iframe = this.inIframe();
    if(this.iframe){
      this.origenVariable = 'origenDestino2'
      this.pickersVariable = 'idaVuelta2'
      this.pickerVueltaVariable = 'vuelta2'
      this.bodyVariable = 'bg-iframe-'+this.mainClass
      this.vamosVariable = 'vamos2'
      this.sencilloredondo = 'sencilloredondo2'
    }

    window.addEventListener('message', function(event) {
        // Check the origin of the message
        /*
        if (event.origin !== 'https://ventas.apoloplatinum.com.mx/') {
            return;
        }
        */
        // Handle the message
        //console.log('evento mensaje')
        //console.log(event.data.text)
        //console.log(event.data.h)
        //this.message = event.data.text+'alto:'+event.data.h;
        //console.log(this.message)
        //document.getElementById('message').innerText = event.data.text;
    });
    //this.noSesion = localStorage.access_token ? true : false;
    const access_token = localStorage.getItem('access_token');
    localStorage.clear();
    localStorage.setItem('access_token', access_token);
    if(access_token === 'null' || access_token === null){
      this.noSesion = true
    }else{
      this.noSesion = false
    }
    localStorage.setItem("value", 0);
    Promise.all([this.obtenercorridas()]).then(
      function () {}
    );
  },
  components: {
    Toggle2,
    AppButton,
    Calendar,
    PasajeroCount,
    DatePicker,
  },
  methods: {
    
    inIframe () {
      try {
        return window.self !== window.top;
      } catch (e) {
          return true;
      }
    },
    
    async obtenercorridas() {
      let config = {
        headers: {
          Accept: "application/vnd.api+json",
          "Content-Type": "application/vnd.api+json",
        },
      };
      axios
        .get("/terminales?page[number]=1&page[size]=1000&linea="+this.linea, config)
        .then((response) => {
          //algoritmo para comparar ciudades con más de una terminal y modificar nombre de terminal
          var array_terminales = response.data.data;
          var terminales = array_terminales;
          array_terminales.forEach(terminal => {
            terminales.forEach((item, index) => {
              if(terminal.attributes.ciudad.attributes.nombre == item.attributes.ciudad.attributes.nombre){
                if(terminal.attributes.nombre != item.attributes.nombre){
                  terminales[index].terminal = item.attributes.nombre+', '+item.attributes.ciudad.attributes.nombre;
                }
              }
            });
          });
          this.ida = terminales;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    notBeforeToday(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },

    async validacion() {
      // Validación Origen y destino
      if (!this.selectida) {
        this.$notify({
          group: "apolo", type: "error",
          title: "Notificación "+process.env.VUE_APP_TITLE,
          text: "Necesitas seleccionar un origen.",
          duration: -1
        });
        return;
      }

      if (!this.selectvuelta) {
        this.$notify({
          group: "apolo", type: "error",
          title: "Notificación "+process.env.VUE_APP_TITLE,
          text: "Necesitas seleccionar un destino.",
          duration: -1
        });
        return;
      }

      // Validación Fecha de ida (siempre requerida)
      if (!this.date) {
        this.$notify({
          group: "apolo", type: "error",
          title: "Notificación "+process.env.VUE_APP_TITLE,
          text: "Necesitas seleccionar una fecha de ida.",
          duration: -1
        });
        return;
      }

      // Validación Fecha de vuelta (solo si es redondo)
      if (this.count === 0 && !this.date2) {
        this.$notify({
          group: "apolo", type: "error",
          title: "Notificación "+process.env.VUE_APP_TITLE,
          text: "Necesitas seleccionar una fecha de vuelta para viaje redondo.",
          duration: -1
        });
        return;
      }

      if (this.date) {
        localStorage.setItem("fecha_ida", this.date.toISOString().split("T")[0]);
      }
      if (this.date2) {
        localStorage.setItem("fecha_vuelta", this.date2.toISOString().split("T")[0]);
      }

      this.conversionFecha();
      this.error = false;

      localStorage.setItem("terminal_ida_id", this.selectida[0]);
      localStorage.setItem("terminal_vuelta_id", this.selectvuelta[0]);
      localStorage.setItem("Abreviatura_ida", this.selectida[3]);
      localStorage.setItem("Abreviatura_vuelta", this.selectvuelta[3]);
      localStorage.setItem("ida", [this.selectida[1] + ", " + this.selectida[2]]);
      localStorage.setItem("vuelta", [this.selectvuelta[1] + ", " + this.selectvuelta[2]]);

      const value = localStorage.getItem("value");
      const fecha_salida = localStorage.getItem("fecha_ida");
      const terminal_origen_id = localStorage.getItem("terminal_ida_id");
      const terminal_destino_id = localStorage.getItem("terminal_vuelta_id");
      const Abreviatura_ida = localStorage.getItem("Abreviatura_ida");
      const Abreviatura_vuelta = localStorage.getItem("Abreviatura_vuelta");
      const ida = localStorage.getItem("ida");
      const vuelta = localStorage.getItem("vuelta");
      const fecha_vuelta = localStorage.getItem("fecha_vuelta");

      if (this.iframe) {
        const routeData = this.$router.resolve({ name: 'paso1', query: {
          value, fecha_salida, terminal_origen_id, terminal_destino_id,
          Abreviatura_ida, Abreviatura_vuelta, ida, vuelta, fecha_vuelta,
          fecha_ida_before: this.date, fecha_vuelta_before: this.date2
        }});
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push("/paso1");
      }
    },

    conversionFecha() {
      //Fecha ida convertir fecha en letra
      let fecha = this.date.toLocaleDateString("es-ES", {
        weekday: "long",
        day: "numeric",
        month: "long",
      });
      fecha = fecha.charAt(0).toUpperCase() + fecha.slice(1);
      fecha = fecha.replace(",", "");
      localStorage.setItem("fecha_ida_convertida", fecha);

      if (this.date2 != null) {
        let fechaVuelta = this.date2.toLocaleDateString("es-ES", {
          weekday: "long",
          day: "numeric",
          month: "long",
        });

        fechaVuelta = fechaVuelta.charAt(0).toUpperCase() + fechaVuelta.slice(1);
        fechaVuelta = fechaVuelta.replace(",", "");
        localStorage.setItem("fecha_vuelta_convertida", fechaVuelta);
      } else {
        localStorage.setItem("fecha_vuelta_convertida", null);
      }
    },

    click() {
      let switch_button = document.getElementById("switch-button");
      switch_button.addEventListener("click", function () {
        this.classList.toggle("switch-active");
      });
    },
    clickRedondo() {
      let switch_button = document.getElementById("switch-button");
      switch_button.addEventListener("click", function () {
        this.classList.toggle("switch-active");
      });
      this.count = 0;
      this.saveCount();
    },
    saveCount() {
      localStorage.setItem("value", this.count);
      //console.log (this.count);
    },
    clickSencillo() {
      let switch_button = document.getElementById("switch-button");
      switch_button.addEventListener("click", function () {
        this.classList.toggle("switch-active");
      });
      this.count = 1;
      this.saveCount();
    },
    hide() {
      {
        {
          var x = document.getElementById("myDIV");
          if (x.style.display === "none") {
            x.style.display = "block";
          } else {
            x.style.display = "none";
          }
        }
      }
    },
  },
};
</script>
